/**
 * Dynamic Content Grid Expand/Collapse Functionality
 * Handles expanding and collapsing of content items in place
 */

class DynamicContentGrid {
  constructor() {
    this.contentItems = document.querySelectorAll('.dynamic-content-item');
    this.expandTriggers = document.querySelectorAll('[data-expand-trigger]');
    this.grid = document.querySelector('.dynamic-content-grid__grid');
    this.expandedItem = null;
    
    this.init();
  }

  init() {
    // Add event listeners for expand/collapse
    this.expandTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => this.toggleExpand(e));
    });

    // Close expanded item on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.expandedItem) {
        this.collapseExpanded();
      }
    });

    // Close expanded item on window resize
    window.addEventListener('resize', () => {
      if (this.expandedItem) {
        this.collapseExpanded();
      }
    });
  }

  toggleExpand(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const trigger = event.currentTarget;
    const contentId = trigger.getAttribute('data-expand-trigger');
    const contentItem = trigger.closest('.dynamic-content-item');
    
    if (!contentItem) return;
    
    if (this.expandedItem === contentItem) {
      this.collapseExpanded();
    } else {
      this.expandItem(contentItem);
    }
  }

  expandItem(contentItem) {
    // Collapse any currently expanded item
    if (this.expandedItem) {
      this.collapseExpanded();
    }
    
    // Expand the new item
    contentItem.classList.add('is-expanded');
    this.expandedItem = contentItem;
    
    // Add class to grid to hide other items
    if (this.grid) {
      this.grid.classList.add('has-expanded');
    }
    
    // Focus management
    const trigger = contentItem.querySelector('[data-expand-trigger]');
    if (trigger) {
      trigger.focus();
    }
    
    // Scroll to expanded item
    contentItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  collapseExpanded() {
    if (!this.expandedItem) return;
    
    // Collapse the expanded item
    this.expandedItem.classList.remove('is-expanded');
    this.expandedItem = null;
    
    // Remove class from grid to show other items
    if (this.grid) {
      this.grid.classList.remove('has-expanded');
    }
    
    // Return focus to the trigger
    const trigger = document.querySelector('.dynamic-content-item.is-expanded [data-expand-trigger]');
    if (trigger) {
      trigger.focus();
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new DynamicContentGrid();
});

// Initialize for dynamically loaded content
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('dynamic-content-grid')) {
    new DynamicContentGrid();
  }
}); 